module.exports = __webpack_public_path__ + "img/img6.cc1c3f57.png";